export const displayAsPercentage = (value) => {
  if (value === undefined || value === null) {
    return "N/A";
  }
  return `${value * 100}%`;
};

export const toHumanReadable = (sentence) => {
  if (!sentence || typeof sentence !== "string") {
    return "N/A";
  }

  return sentence
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between camelCase words
    .toLowerCase() // Convert to lowercase
    .replace(/(^|\s)\S/g, (letter) => letter.toUpperCase()) // Capitalize the first letter of each word
    .trim(); // Remove extra spaces
};
